const formEquipmentActions = {
  notFoundActions: 'No se encontró ninguna acción',
  loadMoreButtonText: 'Mostrar más',
};

export default formEquipmentActions;
